
import StartSwiper from "./components/startSwiper";
import Nav from "./components/Nav";
import AnimateOnPageLinks from "./components/AnimateOnPageLinks";
import BalanceText from "./components/BalanceText";

// Initialise our components on jQuery.ready…
 jQuery(function ($) {
    StartSwiper.init();
    AnimateOnPageLinks.init();
    Nav.init();
    BalanceText.init();
 });


/* const $ = window.jQuery;


window.onscroll = function() {myFunction()};

 var header = document.getElementById("header");
 var sticky = header.offsetTop;
 var headerHeight = $('header').outerHeight();
 function myFunction() {
 if (window.pageYOffset > sticky) {
     header.classList.add("sticky");
   
 } else {
     header.classList.remove("sticky");

 }
}

    */

/* function fixedPadding() {
   var headerHeight = jQuery('header').outerHeight();
  
   var scroll = jQuery(window).scrollTop();
   if (scroll >= headerHeight) {

    jQuery(document).find('body').css('padding-top', headerHeight);
   } else {

    jQuery(document).find('body').css('padding-top', 0);
   }
}

fixedPadding();
jQuery(window).on('scroll',fixedPadding());
jQuery(window).resize(function() {
 fixedPadding();
});

jQuery(window).load(function() {
 fixedPadding();
});
 */


sticky_header();
        
function sticky_header() {
    var headerHeight = jQuery('header').outerHeight();
    var scroll = jQuery(window).scrollTop();
    if (scroll >= headerHeight) {

        jQuery("#header").addClass("state--scrolled");
     
    } else {

        jQuery("#header").removeClass("state--scrolled");
      
    }
}
   
// Add class state--scrolled to body
jQuery(window).on('scroll', sticky_header);  
jQuery(window).on('load', sticky_header);  
jQuery(window).on('resize', sticky_header);  